import React, { useState } from "react";
import { Stack, Typography, styled, Avatar, Box } from "@mui/material";

const Card = styled(Stack)(({ theme }: any) => ({
  justifyContent: "space-evenly",
  width: "275px",
  height: "322px",
  border: `1px solid ${theme.palette.common.borderGrey}`,
  alignItems: "center",
}));

interface SpeakerCardInterface {
  image: string;
  name: string;
  position: string;
  events: number;
  followers: number;
}

const SpeakerCard = ({
  image,
  name,
  position,
  events,
  followers,
}: SpeakerCardInterface) => {
  const [bookmarked, setBookmarked] = useState(false);
  return (
    <Card>
      <Stack alignSelf="center">
        <Avatar
          alt="Remy Sharp"
          src={image}
          sx={{ width: "128px", height: "128px" }}
        />
      </Stack>
      <Typography color="primary" variant="h3" fontWeight={700}>
        {name}
      </Typography>
      <Typography>{position}</Typography>
      <Stack display="flex" flexDirection="row" alignItems="center">
        <Typography fontWeight={500}>{events} events </Typography>
        <Box
          width=" 7px"
          height="7px"
          style={{ backgroundColor: "black", borderRadius: "10px" }}
          ml={1}
          mr={1}
        />
        <Typography fontWeight={500}>{followers} followers</Typography>
      </Stack>
      <Stack>
        {bookmarked ? (
          <i
            className="fas fa-bookmark"
            onClick={() => setBookmarked(!bookmarked)}
          />
        ) : (
          <i
            className="far fa-bookmark"
            onClick={() => setBookmarked(!bookmarked)}
          />
        )}
      </Stack>
    </Card>
  );
};
export default SpeakerCard;
